const PAGE_SIZE = 1000;

/**
 * Fetches all rows from a Supabase query, paginating past the default 1000-row limit.
 * Pass a function that receives (from, to) range params and returns a Supabase query promise.
 * 
 * @example
 * const data = await fetchAllRows((from, to) =>
 *   supabase.from("attendances").select("id, session_id").eq("paid", false).range(from, to)
 * );
 */
export async function fetchAllRows<T = Record<string, unknown>>(
  queryBuilder: (from: number, to: number) => PromiseLike<{ data: T[] | null; error: any }>
): Promise<T[]> {
  let allData: T[] = [];
  let offset = 0;
  let hasMore = true;

  while (hasMore) {
    const { data, error } = await queryBuilder(offset, offset + PAGE_SIZE - 1);
    
    if (error) {
      console.error("Paginated fetch error:", error);
      throw error;
    }
    
    if (data && data.length > 0) {
      allData = allData.concat(data);
      offset += PAGE_SIZE;
      hasMore = data.length === PAGE_SIZE;
    } else {
      hasMore = false;
    }
  }

  return allData;
}
